// Flow types automatically removed

import { string, func } from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button';
import { types } from '../utils/constants';
export const SuccessTitle = ({ type }) => (
    <FormattedMessage
        id="shareModal.response.success.title"
        defaultMessage={`
            {type, select,
                CATALOG {Catalog Shared}
                ITEMS {Items Shared!}
                FOLDERS {Folder Shared!}
                INVOICE {Invoice Shared!}
                DESIGN_PROFILE {Message Sent!}
                other {Item Shared!}
            }
        `}
        values={{
            type,
        }}
    />
);
SuccessTitle.propTypes = {
    type: string.isRequired,
};
export const SuccessDescription = ({ type, closeModal }) => {
    if (type === types.INVOICE) {
        return (
            <Button dataTn="close-btn" onClick={closeModal}>
                <FormattedMessage id="shareModal.response.success.invoice" defaultMessage="Close" />
            </Button>
        );
    }

    return (
        <FormattedMessage
            id="shareModal.response.success.description"
            defaultMessage={`
                {type, select,
                    CATALOG {You successfully shared this catalog}
                    ITEMS {Your items were shared successfully}
                    FOLDERS {Your folder was shared successfully}
                    DESIGN_PROFILE {Your message was sent successfully}
                    other {Your item was shared successfully}
                }
            `}
            values={{
                type,
            }}
        />
    );
};
SuccessDescription.propTypes = {
    closeModal: func,
    type: string.isRequired,
};
export const ErrorTitle = ({ type }) => (
    <FormattedMessage
        id="shareModal.response.error.title"
        defaultMessage={`
            {type, select,
                ITEMS {Error}
                FOLDERS {Error}
                INVOICE {Share Failed}
                DESIGN_PROFILE {Error}
                other {Error}
            }
        `}
        values={{
            type,
        }}
    />
);
ErrorTitle.propTypes = {
    type: string.isRequired,
};
export const ErrorDescription = ({ type }) => (
    <FormattedMessage
        id="shareModal.response.error.description"
        defaultMessage={`
            {type, select,
                CATALOG {Sorry, there was an error in sharing this catalog. Please try again.}
                ITEMS {Sorry there was an error sharing your item(s), please try again.}
                FOLDERS {Sorry there was an error sharing your folder, please try again.}
                INVOICE {Please try again later.}
                DESIGN_PROFILE {Please try again later.}
                other {Sorry there was an error sharing your item, please try again.}
            }
        `}
        values={{
            type,
        }}
    />
);
ErrorDescription.propTypes = {
    type: string.isRequired,
};
